import { types } from 'mobx-state-tree';

export const TAPlanGeometryAttributes = types.model('TAPlanGeometryAttributes', {
  gid: types.maybeNull(types.string),
  objectType: types.integer,
  comment: types.maybe(types.string),
  snapshotIndex: types.maybeNull(types.integer),
  regulationType: types.maybe(types.integer),
  rotation: 0
});
